import { render, staticRenderFns } from "./server-pople.vue?vue&type=template&id=8eb635aa&scoped=true"
import script from "./server-pople.vue?vue&type=script&lang=js"
export * from "./server-pople.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8eb635aa",
  null
  
)

export default component.exports